import { render, staticRenderFns } from "./Exbitorshall.vue?vue&type=template&id=0588e602&scoped=true"
import script from "./Exbitorshall.vue?vue&type=script&lang=js"
export * from "./Exbitorshall.vue?vue&type=script&lang=js"
import style0 from "./Exbitorshall.vue?vue&type=style&index=0&id=0588e602&prod&scoped=true&lang=css"
import style1 from "./Exbitorshall.vue?vue&type=style&index=1&id=0588e602&prod&lang=css"
import style2 from "./Exbitorshall.vue?vue&type=style&index=2&id=0588e602&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0588e602",
  null
  
)

export default component.exports